module.exports = __webpack_public_path__ + "img/banner04-mobile.6ca1d1be.webp";